/**
 * CSS org chart — visual match of info/org_structure/bg.jpg (no raster image).
 * Layout stays LTR so the diagram matches the original artwork.
 */
export default function OrgChartDiagram({ chart, ariaLabel }) {
  if (!chart) return null;

  const depts = chart.departments || [];

  return (
    <div className="ab-org-chart" role="img" aria-label={ariaLabel || ''}>
      <div className="ab-org-chart-spine">
        <div className="ab-org-node ab-org-node--ga">{chart.generalAssembly}</div>
        <div className="ab-org-vline" aria-hidden="true" />

        <div className="ab-org-node ab-org-node--council">{chart.council}</div>

        <div className="ab-org-split ab-org-split--dashed">
          <div className="ab-org-split-arm ab-org-split-arm--left">
            <div className="ab-org-node ab-org-node--council ab-org-node--branch">{chart.bureau}</div>
            <div className="ab-org-hline ab-org-hline--dashed" aria-hidden="true" />
          </div>
          <div className="ab-org-split-arm ab-org-split-arm--right">
            <div className="ab-org-hline ab-org-hline--dashed" aria-hidden="true" />
            <div className="ab-org-node ab-org-node--beige ab-org-node--branch-wide">{chart.committees}</div>
          </div>
        </div>

        <div className="ab-org-vline" aria-hidden="true" />

        <div className="ab-org-node ab-org-node--president">{chart.president}</div>

        <div className="ab-org-split">
          <div className="ab-org-split-arm ab-org-split-arm--left">
            <div className="ab-org-node ab-org-node--purple ab-org-node--stack">
              <span>{chart.purpleTop}</span>
              <span>{chart.purpleBottom}</span>
            </div>
            <div className="ab-org-hline" aria-hidden="true" />
          </div>
          <div className="ab-org-split-arm ab-org-split-arm--right">
            <div className="ab-org-hline" aria-hidden="true" />
            <div className="ab-org-node ab-org-node--auditor">{chart.auditor}</div>
          </div>
        </div>

        <div className="ab-org-vline" aria-hidden="true" />

        <div className="ab-org-node ab-org-node--sg">{chart.secretaryGeneral}</div>

        <div className="ab-org-split ab-org-split--managers">
          <div className="ab-org-split-arm ab-org-split-arm--left">
            <div className="ab-org-node ab-org-node--dept ab-org-node--managers">{chart.chambersManagers}</div>
            <div className="ab-org-hline" aria-hidden="true" />
          </div>
        </div>

        <div className="ab-org-dept-wrap">
          <div className="ab-org-vline ab-org-vline--to-depts" aria-hidden="true" />
          <div className="ab-org-dept-rail" aria-hidden="true" />
          <div className="ab-org-dept-row">
            {depts.map((label, i) => (
              <div key={label} className="ab-org-dept-cell">
                <div className="ab-org-vline ab-org-vline--dept-stub" aria-hidden="true" />
                <div
                  className={`ab-org-node ab-org-node--dept${i === 0 ? ' ab-org-node--dept-dashed' : ''}`}
                >
                  {label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
